<template>
    <div>      
        <VideoComp ref="video" v-if="ready" :x="$px" :y="$py" :src="video" :scale="1" />
    </div>
</template>

<script>

import Matter from 'matter-js'
import Mixin from '@/mixins/Experience'
import VideoComp from '@/components/VideoComp.vue'

export default {

    name: 'Ruban',
    mixins: [ Mixin ],
    components: { VideoComp },

    data: () => ({
        ready: false, 
        completed: false,
        video: 'coeur'
    }),

    beforeDestroy() {

        this.$container_ruban.removeChild(this.$ribbon)
        this.$container_ruban.removeChild(this.$mask)
    },

    created() { this.$container_ruban = this.$parent.$container_ruban
    },

    mounted() {

        this.$px = 432
        this.$py = 786
        this.addBackground('ruban')
    },

    methods: {

        addVideo() {

            this.ready = true
        },


        addMask(sprite) {


            this.$ribbon = sprite

            // this.$mask = new PIXI.Sprite.fromImage(require('@/assets/ruban/mask.png'));
            // this.$mask.anchor.set(0.5)

            // let graphics = new PIXI.Graphics()
            //     graphics.beginFill(0xFFFFFF)
            //     graphics.drawRect(0, 50, 100, 100)
            //     graphics.endFill();
            //     graphics.beginFill(0x000000, 1)
            //     graphics.drawCircle(0, 0, 85)
            //     graphics.endFill()

            var mask = new PIXI.Graphics()
                .beginFill(0xFF0000)
                .moveTo(-500, -500)
                .lineTo(500, -500)
                .lineTo(500, 500)
                .lineTo(-500, 500)
                .moveTo(0, -135)
                .lineTo(20, -130)
                .lineTo(40, -120)
                .lineTo(50, -115)
                .lineTo(60, -110)
                .lineTo(80, -80)
                .lineTo(80, -60)
                .lineTo(80, -40)
                .lineTo(80, -20)
                .lineTo(80, 60)
                .lineTo(0, 60)
                .lineTo(-80, 60)
                .lineTo(-80, -20)
                .lineTo(-80, -40)
                .lineTo(-80, -60)
                .lineTo(-80, -80)
                .lineTo(-60, -110)
                .lineTo(-50, -115)
                .lineTo(-40, -120)
                .lineTo(-20, -130)
                .addHole();


            this.$mask = mask

            // const texture = graphics.generateCanvasTexture()
            // this.$mask = new PIXI.Sprite(texture)
            // this.$mask.anchor.set(0.5, 0.75)
            
            this.$mask.position.set(540, 960)
            this.$ribbon.mask = this.$mask;
            this.$container_ruban.addChild(this.$mask)

        },

        addRibbon() {

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/ruban/ruban.png')))
                sprite.anchor.x = 0.5
                sprite.anchor.y = 0.5
                sprite.position.set(this.$width/2, this.$height/2)
                sprite.scale.set(1*this.$coef, 1*this.$coef)
                sprite.alpha = 0

            this.$container_ruban.addChild(sprite)
            this.$ribbon = sprite
        },

        backgroundCompleted() { this.addElements()
        },

        addElements() {

            const els = [

                { id: 'screen', x:540, y: 960, ax: 0.5, ay: 0.5 },
                { id: 'tagline_1', x:278, y: 1148, ax: 0.5, ay: 0.5 },
                { id: 'tagline_2', x:258, y: 1302, ax: 0.5, ay: 0.5 },
                { id: 'tagline_3', x:290, y: 1436, ax: 0.5, ay: 0.5 },
                { id: 'tagline_4', x:290, y: 1580, ax: 0.5, ay: 0.5 },
                { id: 'tagline_5', x:303, y: 1755, ax: 0.5, ay: 0.5 },
            ]

            _.each(els, (el)=>{ this['$'+ el.id] = this.getSprite(el) })
            this.showElements()
        },

        showElements() {

            this.$tempo = 0
            this.$tween = new TimelineMax({
                delay: 0.5,
                
            })
            .add([

                TweenMax.to(this.$parent.$black, 0.5, { alpha: 0, ease: Linear.easeNone, delay: 0 }),
                TweenMax.from(this.$tagline_1, 1.4, { y:2400, delay: this.$tempo + 0, ease: Expo.easeOut }),
                TweenMax.from(this.$tagline_2, 1.5, { y:2400, delay: this.$tempo + 0.2, ease: Expo.easeOut }),
                TweenMax.from(this.$tagline_3, 1.8, { y:2400, delay: this.$tempo + 0.4, ease: Expo.easeOut }),
                TweenMax.from(this.$tagline_4, 1.8, { y:2400, delay: this.$tempo + 0.6, ease: Expo.easeOut, onComplete:()=>{
                    this.$refs.video.play()
                } }),
                TweenMax.from(this.$tagline_5, 1.8, { y:2400, delay: this.$tempo + 0.8, ease: Expo.easeOut }),
                TweenMax.from(this.$screen, 0.5, { alpha: 0, delay: 5.5, onStart: ()=>{ 
                    this.$parent.resetRecord()
                } }),
            ])  

            this.$tween = TweenMax.delayedCall(0, this.addVideo)     
        },

        getSprite(data) {

            const sp = data.id.split('_')
            const id = (sp[0] == 'tagline' && sp.length>1) ? ('tagline/'+ sp[1])  : data.id

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/ruban/'+ id +'.png')))
                sprite.anchor.x = data.ax
                sprite.anchor.y = data.ay
                sprite.position.set(data.x*this.$coef, data.y*this.$coef)

                if(id === 'screen')
                    sprite.scale.set(2,2)
                // sprite.alpha = 0

            this.$foreground.addChild(sprite)
            this.$sprites_foreground.push(sprite)
            return sprite
        },

        addBackground(arg) {

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/ruban/bkg.png')))
                    sprite.anchor.x = 0.5
                    sprite.anchor.y = 0.5
                    sprite.position.set(this.$width/2, this.$height/2)
                    sprite.scale.set(1*this.$coef, 1*this.$coef)

            this.$background.addChild(sprite)
            this.$sprites_background.push(sprite)
            this.$bkg = sprite
            this.$tween = TweenMax.from(this.$bkg, 0.50, { alpha: 0, ease:Linear.easeNone, delay: 0.5, onComplete: this.backgroundCompleted })
        },

        animate() {

            if(this.$mask) {

                const pos = this.$parent.$face_0.position
                const poy = pos.y+25
                
                this.$mask.position.set(pos.x, poy)
                this.$mask.scale.set(this.$parent.$old[0], this.$parent.$old[0]) 
                // this.$ribbon.position.y = poy
                // this.$screen.position.y = poy + 80
            } 
        },
    }
}
</script>




















